import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IoArrowBack } from 'react-icons/io5';
import '../styles/PrivacyPage.css';

const PrivacyPage = () => {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1); // Go back to the previous page
    };

    return (
        <div className="privacy-container">
            <div className="privacy-box">
                <button 
                    className="back-button" 
                    onClick={handleGoBack}
                    type="button"
                >
                    <IoArrowBack /> Back
                </button>
                
                <h2>Privacy Policy</h2>
                <p className="effective-date">Effective date: {new Date().toLocaleDateString()}</p>

                <p>Rasmoose ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and store your personal data when you use our website and services.</p>

                <h3>1. Who We Are</h3>
                <p>This website is operated by Sebastian Wodecki, a student based in the EU. You can contact us at: wodecki.sg@gmail.com
                .</p>

                <h3>2. What Data We Collect</h3>
                <p>We collect the following types of data when you interact with Rasmoose:</p>
                <ul>
                    <li>Email address and username when you sign up</li>
                    <li>Student email address, if you choose to verify your student status</li>
                    <li>Google account info if you sign in with Google</li>
                    <li>IP address and device info (automatically via Firebase)</li>
                    <li>Content you publish, such as reviews or messages in the public chat</li>
                </ul>
                <p>We do not collect any sensitive personal data.</p>

                <h3>3. How We Use Your Data</h3>
                <p>We use your data to:</p>
                <ul>
                    <li>Provide authentication and secure access (via Firebase Auth)</li>
                    <li>Verify your student status to grant access to features like reviews and to display a "Verified Student" badge</li>
                    <li>Allow you to post reviews and interact with other users</li>
                    <li>Maintain security and detect abuse</li>
                    <li>Improve user experience</li>
                </ul>

                <h3>4. Use of Firebase and Google</h3>
                <p>We use Firebase services by Google LLC for authentication and data storage. Google may collect technical information such as IP address and browser settings as part of their infrastructure services.</p>
                <p>You can read more about Firebase's privacy practices here: <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer">https://firebase.google.com/support/privacy</a></p>

                <h3>5. Email Communications</h3>
                <p>We use a third-party email service (Resend) to send you transactional emails, such as the one required to verify your student email address. We do not use your email for marketing communications.</p>

                <h3>6. Cookies</h3>
                <p>We use only strictly necessary cookies for login sessions and authentication. These cookies:</p>
                <ul>
                    <li>Do not track your activity across other websites</li>
                    <li>Are essential for logging in and staying logged in</li>
                </ul>
                <p>We do not use Google Analytics, advertising cookies, or tracking cookies.</p>

                <h3>7. Your Rights (under GDPR)</h3>
                <p>As a user based in the EU, you have the right to:</p>
                <ul>
                    <li>Access your personal data</li>
                    <li>Request correction or deletion</li>
                    <li>Withdraw consent at any time</li>
                    <li>File a complaint with a data protection authority</li>
                </ul>
                <p>To exercise these rights, contact us at: wodecki.sg@gmail.com.</p>

                <h3>8. Data Retention</h3>
                <p>We retain your data for as long as your account is active. You may request account deletion at any time.</p>

                <h3>9. Changes</h3>
                <p>We may update this policy occasionally. The latest version will always be available on this page.</p>

                <h3>10. Use of Umami Analytics</h3>
                <p>We use Umami, a privacy-focused analytics service, to help us understand how users interact with our website. Umami collects anonymous usage statistics—such as page visits, referrers, device type, operating system, and browser type—without storing personal data (such as names, emails, or IP addresses), and without the use of cookies.</p>
                <p>The analytics data collected through Umami is strictly anonymized and cannot be used to identify you. We use this information solely to improve our website's performance, monitor traffic, and enhance user experience. This data is processed and stored on Umami servers according to their privacy standards. No analytics data is sold or shared with third parties for marketing purposes.</p>
                <p>Since Umami does not collect personal information, there is no personal data to access, change, or delete. If you have any concerns regarding analytics data, please contact us.</p>
            </div>
        </div>
    );
};

export default PrivacyPage; 